import viewCustomer from './viewCustomer';

export default {
	viewCustomerPage: viewCustomer
}